module.exports = __webpack_public_path__ + "img/training_mix1.7108887d.jpg";